import { render, staticRenderFns } from "./SupplierFeedback.vue?vue&type=template&id=c81ee698&"
import script from "./SupplierFeedback.vue?vue&type=script&lang=js&"
export * from "./SupplierFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports